import { XIcon } from "@heroicons/react/outline";
import { FilePlus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { AddFilePopover } from "@/components/ui/FileDisplay/FileDisplayContent/AddFilePopover";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface VariableActionsProps {
  hasValue: boolean;
  showAddFileButton?: boolean;
  onAddFiles: (fileUrls: string[]) => void;
  onDelete: () => void;
  removeTooltip?: string;
  readOnly?: boolean;
  popoverPortalContainer?: HTMLElement | null;
}

const VariableActions = ({
  hasValue,
  showAddFileButton = true,
  onAddFiles,
  onDelete,
  removeTooltip,
  readOnly = false,
  popoverPortalContainer,
}: VariableActionsProps) => {
  if (readOnly) {
    return null;
  }

  return (
    <div className="flex items-center gap-x-1">
      {!hasValue && showAddFileButton && (
        <BasicTooltip content="Add files" usePortal={false}>
          <span>
            <AddFilePopover onAddFiles={onAddFiles} popoverPortalContainer={popoverPortalContainer}>
              <Button variant="ghost" size="tinyIcon" tabIndex={-1}>
                <FilePlus className="h-4 w-4" />
              </Button>
            </AddFilePopover>
          </span>
        </BasicTooltip>
      )}
      <BasicTooltip content={removeTooltip || "Remove variable"}>
        <Button
          onClick={onDelete}
          variant="destructiveLink"
          size="sm"
          className="h-9 w-9 p-0"
          aria-label="Delete variable"
        >
          <XIcon className="h-4 w-4" />
        </Button>
      </BasicTooltip>
    </div>
  );
};

export default VariableActions;
